import React, { useMemo } from 'react';
import { CellTypes, Column } from '~/Components/DataTable/DataTable.types';
import { useDateFns, useLanguage } from '~/Hooks';
import { AttendanceStatus, AttendanceStatusType } from '~/Models/DTO/Attendance.model';
import { StatusTag } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

type IAttendanceColumnNameType = 'name' | 'eventName' | 'eventType' | 'location' | 'date' | 'time';

const useStyles = makeStyles(() => ({
  status: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 16,
  },
}));

export const useAttendanceColumns = () => {
  const { t } = useLanguage();
  const { formatDate } = useDateFns();
  const { classes } = useStyles();

  const columnMap: {
    [key in IAttendanceColumnNameType]: Column;
  } = useMemo(
    () => ({
      name: {
        label: t('app.checkin.table.name'),
        propertyIds: 'customerName',
        cellType: CellTypes.String,
      },
      eventName: {
        label: t('app.checkin.table.eventName'),
        propertyIds: 'eventName',
        cellType: CellTypes.String,
      },
      eventType: {
        label: t('app.checkin.table.eventType'),
        propertyIds: 'eventType',
        cellType: CellTypes.String,
      },
      location: {
        label: t('app.checkin.table.location'),
        propertyIds: 'locationName',
        style: { width: '25%' },
        cellType: CellTypes.String,
      },
      date: {
        label: t('app.checkin.table.date'),
        propertyIds: 'checkInTime',
        cellType: CellTypes.String,
        formatter: (value: string) => formatDate(value, 'dd MMM yyyy'),
      },
      time: {
        label: t('app.checkin.table.checkin'),
        propertyIds: ['checkInTime', 'bookingState'],
        cellType: CellTypes.String,
        style: { width: '20%' },
        formatter: (value) => (
          <div className={classes.status}>
            <span>{formatDate(value.checkInTime, 'HH:mm')}</span>
            {value.bookingState ? (
              <StatusTag status={AttendanceStatusType[value.bookingState]}>
                {AttendanceStatus[value.bookingState]}
              </StatusTag>
            ) : (
              <StatusTag status={AttendanceStatusType.Pending}>
                {AttendanceStatus.Pending}
              </StatusTag>
            )}
          </div>
        ),
      },
    }),
    [t],
  );
  return {
    columnMap,
  };
};
